/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamRevisionGrid200,
  GetApiV1ExamRevisionGrid401,
  GetApiV1ExamRevisionGrid500,
  GetApiV1ExamRevisionGridQueryParams,
  GetApiV1ExamRevisionGridQueryResponse,
} from "../../types/examRevisionController/GetApiV1ExamRevisionGrid.ts";
import { classroomDisciplineBotExamGridItemRepositoryResponseSchema } from "../classroomDisciplineBotExamGridItemRepositoryResponseSchema.ts";

export const getApiV1ExamRevisionGridQueryParamsSchema = z.object({
  disciplineId: z.optional(z.coerce.number().int()),
  classStudentId: z.optional(z.coerce.number().int()),
  date: z.optional(z.string().datetime()),
  pageNumber: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1ExamRevisionGridQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamRevisionGrid200Schema = z.array(
  z.lazy(() => classroomDisciplineBotExamGridItemRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ExamRevisionGrid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamRevisionGrid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionGrid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamRevisionGrid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionGrid500>;

export const getApiV1ExamRevisionGridQueryResponseSchema = z.lazy(
  () => getApiV1ExamRevisionGrid200Schema,
) as unknown as ToZod<GetApiV1ExamRevisionGridQueryResponse>;
